import * as React from "react";
const SvgBackupTable = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6v14H6v2h16V6z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 2H2v16h16V2zM9 16H4v-5h5v5zm7 0h-5v-5h5v5zm0-7H4V4h12v5z",
  fill: "currentColor"
}));
export default SvgBackupTable;